<template>
  <div>
    <div style="width: 95%;margin: 0 auto;">
      <el-form :model="info" class="demo-form-inline" label-width="150px" :rules="rules" ref="info">
        <el-form-item label="关联产品" prop="pay_type">
          <el-select v-model="info.pay_type" medium clearable placeholder="请选择关联产品" style="width: 400px;">
            <el-option v-for="(item,index) in optionsList" :label="item.mer_name" :value="item.mer_type">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品名称" prop='merch_name'>
          <el-input clearable v-model="info.merch_name" placeholder="请输入商品名称" style="width: 400px;"></el-input>
        </el-form-item>

        <el-form-item label="购买方式" prop="buy_type">
          <el-radio-group v-model="info.buy_type" @change="changebuyType">
            <el-radio label="10">现金</el-radio>
            <el-radio label="20">积分</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="商品价格" prop="price" v-if="info.buy_type == 10">
          <el-input clearable v-model="info.price" placeholder="请输入商品价格" style="width: 400px;"></el-input>
        </el-form-item>
        <el-form-item label="积分" prop="coin" v-if="info.buy_type == 20">
          <el-input clearable v-model="info.coin" placeholder="请输入积分" style="width: 400px;"></el-input>
        </el-form-item>

        <el-form-item label="封面图片" prop="banner_url" style="margin-bottom: 17px;">
          <el-upload
              ref="uploads"
              class="avatar-uploader "
              :action="uploadImgUrl"
              list-type="picture-card"
              :on-success="handleAvatarSuccess"
              :on-error="handleUploadError"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              :headers="headers"
              :limit="1"
              :on-exceed="onExceed"
              :file-list="fileList"
              style="width: 500px"
          >
            <i class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisibleImg123" append-to-body>
            <div class="demo-image__preview">
              <el-image width="100%" :src="info.banner_url" alt=""></el-image>
            </div>
          </el-dialog>
        </el-form-item>

        <el-form-item label="营销标签" prop="marketing_lable">
          <el-input clearable v-model="info.marketing_lable" placeholder="请输入营销标签" style="width: 400px;">
          </el-input>
        </el-form-item>
		<el-form-item label="兑换台数(小于等于)" prop="exchange_num"  v-if="info.buy_type == 20">
		  <el-input clearable v-model="info.exchange_num" placeholder="请输入兑换台数" style="width: 400px;">
		  </el-input>
		</el-form-item>
		<el-form-item label="快递费" prop="express_price"  v-if="info.buy_type == 20">
		  <el-input clearable v-model="info.express_price" placeholder="请输入快递费" style="width: 400px;">
		  </el-input>
		</el-form-item>
        <el-form-item label="库存数量" prop="stock">
          <el-input clearable v-model="info.stock" placeholder="请输入库存数量" style="width: 400px;"></el-input>
        </el-form-item>
        <el-form-item label="终端台数" prop="pos_num">
          <el-input clearable v-model="info.pos_num" placeholder="请输入终端台数" style="width: 400px;"></el-input>
        </el-form-item>
        <el-form-item label="是否上架" prop="merch_status">
          <el-radio-group v-model="info.merch_status">
            <el-radio label="Y">上架</el-radio>
            <el-radio label="N">下架</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="商品介绍" prop="content" style="width: 800px">
          <template style="width: 800px">
            <div style="margin-bottom: 20px;width: 800px" >
              <!--  新增时输入 -->
              <quill-editor v-model="info.content" ref="myQuillEditor" :options="editorOption">
              </quill-editor>
            </div>
          </template>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm()">确 定</el-button>
          <el-button @click="backUrl()">取 消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import {
  quillEditor
} from "vue-quill-editor"; //调用编辑器
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

export default {
  name: "productDetails",
  components: {
    quillEditor,
  },
  data() {
    return {
      optionsList: [],
      info: {
        sub_mer_one: 1,
        buy_type: '10',
        merch_status: "Y",
        banner_url: '',
        coin: 0,
      },
      editorOption: {},
      rules: {
        pay_type: [{
          required: true,
          message: '请选择关联产品',
          trigger: 'change'
        }],
        merch_name: [{
          required: true,
          message: '请输入商品名称',
          trigger: 'blur'
        },],
        buy_type: [{
          required: true,
          message: '请选择购买方式',
          trigger: 'change'
        }],
        price: [{
          required: true,
          message: '请输入商品价格',
          trigger: 'blur'
        },],
        coin: [{
          required: true,
          message: '请输入积分',
          trigger: 'blur'
        },],
        marketing_lable: [{
          required: true,
          message: '请输入营销标签',
          trigger: 'blur'
        },],
		exchange_num: [{
		  required: true,
		  message: '请输入兑换台数（小于等于）',
		  trigger: 'blur'
		},],
		express_price: [{
		  required: true,
		  message: '请输入快递费',
		  trigger: 'blur'
		},],
        stock: [{
          required: true,
          message: '请输入库存数量',
          trigger: 'blur'
        },],
        pos_num: [{
          required: true,
          message: '请输入终端台数',
          trigger: 'blur'
        },],
        merch_status: [{
          required: true,
          message: '请选择是否上架',
          trigger: 'change'
        }],
        content: [{
          required: true,
          message: '请填写活动形式',
          trigger: 'blur'
        }],
        banner_url: [
          {required: true, message: '请上传图片', trigger: 'blur'}
        ],
      },
      headers: {  // 请求头部参数
        token: sessionStorage.getItem('token')
      },
      uploadImgUrl: "/api/system/uploadFile", // 上传图片的后台controller的地址
      dialogVisibleImg123: false,
      fileList: [],
      id: this.$route.query.id || null,
      radioType: 10,
    }
  },
  created() {
    this.getData()
    if (this.id != null) {
      this.details()
    }
  },
  methods: {
    changebuyType(val) {
      this.radioType = val;
      if (val == 10) {
        this.coin = 0;
      } else if (val == 20) {
        this.price = 0;
      }
    },
    //编辑 获取详情
    details() {
      this.$api.post("/api/goods/detail", {id: this.id}, res => {
        if (res.status == 200) {
          this.info = res.data;
          this.info.buy_type = res.data.buy_type.value;
          this.info.merch_status = res.data.merch_status.value;
          this.info.pay_type = res.data.pos_type.value;
          this.fileList = [{
            name: res.data.banner_type.text,
            url: res.data.banner_url,
          }]
          this.$delete(this.info, 'banner_type');
          this.$delete(this.info, 'pos_type');
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    //提交
    submitForm() {
      this.$refs['info'].validate((valid) => {
        if (valid) {
          this.$api.post("/api/goods/form", this.info, res => {
            if (res.status == 200) {
              this.$message.success(res.msg);
              // this.info = {
              //   sub_mer_one: 1,
              //   buy_type: '10',
              //   merch_status: "Y",
              //   banner_url: '',
              //   coin: 0
              // }
              // this.fileList = [];
            } else {
              this.$message.error(res.msg);
            }
          })
        } else {
          return false;
        }
      });
    },
    //获取数据
    getData() { //初始化数据
      this.$api.post("/api/goods/goodsBase", {}, res => {
        if (res.status == 200) {
          this.optionsList = res.data
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    //返回上一页
    backUrl() {
      this.$router.back()
    },
    //上传图片
    handleAvatarSuccess(res) {
      if (res.status == 200) {
        this.info.banner_url = res.data.url;
        this.$message({
          message: '图片上传成功',
          type: 'success'
        });
      } else {
        this.$message({
          message: res.msg,
          type: 'error'
        });
        this.fileList = []
      }
    },
    onExceed() {
      this.$message({
        type: 'warning',
        message: '当前限制选择 1 个文件，本次选择了 1 个文件，共选择了 2 个文件',
        duration: 1000,
      });
    },
    handleUploadError() {
      this.$message({
        type: "error",
        message: "上传失败",
      });
      this.info.banner_url = '';
    },
    handleRemove(file) {
      this.info.banner_url = '';
    },
    handlePictureCardPreview(file) {
      this.dialogVisibleImg123 = true;
    },
  }
}
</script>

<style scoped>
/deep/ .el-form-item__content .el-input-group {
  vertical-align: middle !important;
}

.code {
  cursor: pointer;
}

.code:hover {
  color: blue;
  text-decoration: underline;
}
/deep/ .ql-container {
  height: 300px !important;
}
</style>
